@if(formReady) {
<div [formGroup]="deviceForm"
     class="content">

  <div class="form-row row p-2">
    <div class="col-12 col-lg-6">
      <div class="form-group row">
        <label for="name"
               class="col-5 control-label required">
          {{'i18n.domain.administration.zone-device-details.form.name' | translate}}
        </label>
        <div class="col-7">
          <input type="text"
                 class="form-control e-textbox"
                 id="name"
                 name="name"
                 formControlName="name"
                 autocomplete="off">
          <app-error-messages [control]="deviceForm.controls.name"></app-error-messages>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-5 control-label">
          {{'i18n.domain.administration.zone-device-details.form.deviceType' | translate}}
        </label>
        <div class="col-7">
          <ejs-dropdownlist [dataSource]="deviceTypes"
                            [fields]="enumDropdownSettings"
                            id="deviceType"
                            [showClearButton]="true"
                            formControlName="deviceType">
            <ng-template #itemTemplate let-data>
              {{data.text | translate}}
            </ng-template>
            <ng-template #valueTemplate let-data>
              <span class='numeric-enum-drop-down-value'>{{data.text | translate}}</span>
            </ng-template>
          </ejs-dropdownlist>
          <app-error-messages [control]="deviceForm.controls.deviceType"></app-error-messages>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-5 control-label">
          {{'i18n.domain.administration.zone-device-details.form.brand' | translate}}
        </label>
        <div class="col-7">
          <ejs-dropdownlist [dataSource]="deviceBrands"
                            [fields]="enumDropdownSettings"
                            id="brand"
                            [showClearButton]="true"
                            formControlName="brand">
            <ng-template #itemTemplate let-data>
              {{data.text | translate}}
            </ng-template>
            <ng-template #valueTemplate let-data>
              <span class='numeric-enum-drop-down-value'>{{data.text | translate}}</span>
            </ng-template>
          </ejs-dropdownlist>
          <app-error-messages [control]="deviceForm.controls.brand"></app-error-messages>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-5 control-label  required">
          {{'i18n.domain.administration.zone-device-details.form.direction' | translate}}
        </label>
        <div class="col-7">
          <ejs-dropdownlist [dataSource]="deviceDirections"
                            [fields]="enumDropdownSettings"
                            id="direction"
                            [showClearButton]="true"
                            formControlName="direction">
            <ng-template #itemTemplate let-data>
              {{data.text | translate}}
            </ng-template>
            <ng-template #valueTemplate let-data>
              <span class='numeric-enum-drop-down-value'>{{data.text | translate}}</span>
            </ng-template>
          </ejs-dropdownlist>
          <app-error-messages [control]="deviceForm.controls.direction"></app-error-messages>
        </div>
      </div>
      <div class="form-group row">
        <label for="description"
               class="col-5 control-label">
          {{'i18n.domain.administration.zone-device-details.form.description' | translate}}
        </label>
        <div class="col-7">
          <input type="text"
                 class="form-control e-textbox"
                 id="description"
                 name="description"
                 formControlName="description"
                 autocomplete="off">
          <app-error-messages [control]="deviceForm.controls.description"></app-error-messages>
        </div>
      </div>
      <div class="form-group row">
        <label for="coordinates"
               class="col-5 control-label">
          {{'i18n.domain.administration.zone-device-details.form.coordinates' | translate}}
        </label>
        <div class="col-7">
          <input type="text"
                 id="coordinates"
                 class="form-control e-textbox"
                 name="coordinates"
                 formControlName="coordinates"
                 autocomplete="off"/>
          <app-error-messages [control]="deviceForm.controls.coordinates"></app-error-messages>
        </div>
      </div>
      @if(isProxyDriven) {
      <div class="form-group row">
        <label class="col-5 control-label required">
          {{'i18n.domain.administration.zone-device-details.form.proxy-user' | translate}}
        </label>
        <div class="col-7">
          <ejs-dropdownlist [dataSource]="proxyUsers"
                            [fields]="proxUserDropdownSettings"
                            id="proxyUserId"
                            [showClearButton]="false"
                            formControlName="proxyUserId">
          </ejs-dropdownlist>
          <app-error-messages [control]="deviceForm.controls.proxyUserId"></app-error-messages>
        </div>
      </div>
      }
      <div class="form-group row">
        <label class="col-5 control-label">{{'i18n.domain.administration.zone-device-details.form.enabled' | translate}}</label>
        <div class="col-7">
          <app-yes-no-group-button id="enabled"
                                  formControlName="enabled">
          </app-yes-no-group-button>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <app-map-box-map [(mapData)]="mapData">
          </app-map-box-map>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
    @if(deviceParameters) {
      <ng-template #paramRow let-param>
        @if (!!param.configuration?.ident) {
          <div class="form-group row">
            <div class="col-12">
              <app-input-factory [formControl]="deviceForm.controls.parameters.get(param.configuration!.ident.split('.')[1])"
                                [label]="param.configuration?.displayName"
                                [inputType]="getInputType(param.type)"
                                [dropdownValues]="deviceParameterSelectOptions.get(param.configuration!.ident.split('.')[1])"
                                [showUntouchedErrors]="!isAdd"
                                [control]="deviceForm.controls.parameters.get(param.configuration!.ident.split('.')[1])"></app-input-factory>
            </div>
          </div>
        }
      </ng-template>

      @if(sectionCount > 1) {
        <div class="d-flex justify-content-end mb-2">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="toggleAllSections()">
            {{ (allSectionsOpen ? 'i18n.domain.administration.zone-device-details.form.collapse-all' : 'i18n.domain.administration.zone-device-details.form.expand-all') | translate }}
          </button>
        </div>
        <ng-container [formGroup]="deviceForm.controls.parameters">
          <div class="accordion accordion-flush">

            @if(ungroupedDeviceParameters.length > 0) {
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button type="button" class="accordion-button" [class.collapsed]="!isOpen(UNGROUPED_KEY)"
                          (click)="toggleSection(UNGROUPED_KEY)">
                    {{'i18n.domain.administration.zone-device-details.form.parameters-group-common' | translate}}
                  </button>
                </h2>
                <div class="accordion-collapse collapse" [class.show]="isOpen(UNGROUPED_KEY)">
                  <div class="accordion-body">
                    @for(param of ungroupedDeviceParameters; track param) {
                      <ng-container [ngTemplateOutlet]="paramRow" [ngTemplateOutletContext]="{$implicit: param}"></ng-container>
                    }
                  </div>
                </div>
              </div>
            }

            @for(group of groupedDeviceParameters; track group.groupName) {
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button type="button" class="accordion-button" [class.collapsed]="!isOpen(group.groupName)"
                          (click)="toggleSection(group.groupName)">
                    {{ group.groupName }}
                  </button>
                </h2>
                <div class="accordion-collapse collapse" [class.show]="isOpen(group.groupName)">
                  <div class="accordion-body">
                    @for(param of group.parameters; track param) {
                      <ng-container [ngTemplateOutlet]="paramRow" [ngTemplateOutletContext]="{$implicit: param}"></ng-container>
                    }
                  </div>
                </div>
              </div>
            }

          </div>
        </ng-container>
      } @else {
        <ng-container [formGroup]="deviceForm.controls.parameters">
          @for(param of ungroupedDeviceParameters; track param) {
            <ng-container [ngTemplateOutlet]="paramRow" [ngTemplateOutletContext]="{$implicit: param}"></ng-container>
          }
          @for(group of groupedDeviceParameters; track group.groupName) {
            @for(param of group.parameters; track param) {
              <ng-container [ngTemplateOutlet]="paramRow" [ngTemplateOutletContext]="{$implicit: param}"></ng-container>
            }
          }
        </ng-container>
      }
    }
    </div>

  </div>

  <div class="detail-footer p-2 pt-3">
  @if(selectedDevice?.id) {
    <button type="button"
            class="btn btn-danger me-auto"
            (click)="deleteDevice()"
            [disabled]="isBusy">
      {{'i18n.domain.administration.zone-device-details.messages.delete-title' | translate}}
    </button>
  }
    <button type="button"
            class="btn btn-secondary me-2"
            (click)="cancelClicked()"
            [disabled]="isBusy">
      {{'i18n.shared.cancel' | translate}}
    </button>
    <button type="button"
            class="btn btn-primary"
            (click)="submitForm()"
            [disabled]="saveButtonDisabled || isBusy">
      {{'i18n.shared.save' | translate}}
    </button>
  </div>
</div>
}

<app-zone-device-add (deviceStructureCreated)="onDeviceStructureCreated($event)" (cancelled)="onAddCancelled()"></app-zone-device-add>
